import { range } from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import Constants from "../../constants";
import { SET_ACTIVE_VIEW_INDEX } from "../../store/actions/viewActions";
import { getActiveViewIndex, getMaxViewIndex } from "../../store/sagas/selectors";

const Container = styled.div`
    position: absolute;
    width: 100%;
    bottom: calc(100% - ${Constants.mobileImageHeightVw}vw - 17px);
    ${({ theme }) => theme.bp.landscape`
        bottom: 16%;
    `}
    display: flex;
    flex-direction: row;
    align-content: stretch;
    justify-content: center;
    pointer-events: none;
    z-index: 10;
`;

const ButtonContainer = styled.div`
    padding: 10px;
    cursor: pointer;
    pointer-events: auto;
`;

const FrameButton = styled.div<FrameButtonParams>`
    border: 2px solid var(--primary-color);
    border-radius: 50%;
    box-sizing: border-box;
    width: 15px;
    height: 15px;
    ${({ theme }) => theme.bp.md`
        width: 18px;
        height: 18px;
    `}
    display: flex;
    justify-content: center;
    align-items: center;
    transition: background 0.2s ease-in-out;
    ${({ selected }) => {
        return selected
            ? "background: var(--primary-color);"
            : `
    background: #fff;
    &:hover {
        background: rgba(230, 230, 230, 1);
    }
    &:active {
        background: rgba(204, 204, 204, 1);
    }
        `;
    }}
`;

interface FrameButtonParams {
    selected: boolean;
}

export const FrameButtons = () => {
    const dispatch = useDispatch();
    const maxIndex = useSelector(getMaxViewIndex);
    const activeIndex = useSelector(getActiveViewIndex);

    return (
        <Container>
            {range(maxIndex + 1).map(i => (
                <ButtonContainer
                    key={i}
                    onClick={() => {
                        dispatch({ type: SET_ACTIVE_VIEW_INDEX, activeViewIndex: i });
                    }}
                >
                    <FrameButton selected={i === activeIndex} />
                </ButtonContainer>
            ))}
        </Container>
    );
};
